import { deleteOfferThunk, getAllOffersThunk } from '@redux/features/offer.slice';
import { AnimatedListSkeleton, AnimatedTable, AnimatedTableBody, AnimatedTableRow } from 'components/animations';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';
import BreadCrumb from 'Common/BreadCrumb';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import React, { FC, useEffect, useState } from 'react';
import AddOfferModal from './AddOfferModal';
import ButtonBase from 'components/ui/buttons/ButtonBase';
import UpdateOfferModal from './UpdateOfferModal';
import UploadImageThumb from 'components/ui/UploadImageThumb';

const Offers: FC = () => {
    const [page, setPage] = useState<string>(`0`);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [showAddOfferModal, setShowAddOfferModal] = useState<boolean>(false);
    const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
    const [offerId, setOfferId] = useState<number>();
    const [productId, setProductId] = useState<number>();

    // -------------------------------------------------------------
    const dispatch = useAppDispatch();
    // -------------------------------------------------------------
    const { offers, loading } = useAppSelector((state: RootState) => state.offerState);
    // -------------------------------------------------------------
    const changePage = (page: string) => {
        setPage(page);
    };

    // Helper function to format staticOffers value
    const formatStaticOffers = (value: string | undefined | null) => {
        if (!value || value === '-') {
            return '-';
        }

        // Replace underscores with spaces
        let formatted = value.replace(/_/g, ' ');

        // Add space before numbers when they follow letters (e.g., "STATIC4" -> "STATIC 4")
        formatted = formatted.replace(/([A-Za-z])(\d)/g, '$1 $2');

        // Add space after numbers when they are followed by letters (e.g., "4STATIC" -> "4 STATIC")
        formatted = formatted.replace(/(\d)([A-Za-z])/g, '$1 $2');

        // Clean up multiple spaces
        formatted = formatted.replace(/\s+/g, ' ').trim();

        return formatted;
    };
    // -------------------------------------------------------------
    useEffect(() => {
        dispatch(getAllOffersThunk());
    }, [page]);
    // -----------------------------------------------------
    console.log(offers);
    // -----------------------------------------------------

    const handleConfirmDelete = async () => {
        if (offerId) {
            dispatch(deleteOfferThunk(offerId)).then((response: any) => {
                if (response.meta.requestStatus === 'fulfilled') {
                    setShowDeleteModal(false);
                    setOfferId(undefined);
                    dispatch(getAllOffersThunk());
                }
            });
        }
    };

    const handleDeleteOffer = (id: number) => {
        setOfferId(id);
        setShowDeleteModal(true);
    };
    const handleUpdateOffer = (id: number, productId: number) => {
        setOfferId(id);
        setProductId(productId);
        setShowUpdateModal(true);
    };
    // -----------------------------------------------------

    return (
        <>
            <UpdateOfferModal
                show={showUpdateModal}
                handleClose={() => setShowUpdateModal(false)}
                offerId={offerId || 0}
                productId={productId || 0}
            />
            <AddOfferModal handleClose={() => setShowAddOfferModal(false)} show={showAddOfferModal} />
            <ConfirmationModal
                show={showDeleteModal}
                handleClose={() => {
                    setShowDeleteModal(false);
                    setOfferId(undefined);
                }}
                onConfirm={handleConfirmDelete}
                title="Delete Offer"
                message="Are you sure you want to delete this offer? This action cannot be undone."
                confirmButtonText="Delete"
                cancelButtonText="Cancel"
                id={offerId}
            />
            <BreadCrumb pageTitle={`Banners List`} />
            <section className="py-5">
                <div className=" p-3 flex flex-col gap-2 bg-[#fff]">
                    <div className="flex w-full items-center justify-between">
                        <h3 className="font-extrabold text-[#bd902e]">Offers List</h3>
                        <ButtonBase innerText="Add Offer" onClick={() => setShowAddOfferModal(true)} />
                    </div>
                    {loading ? (
                        <AnimatedListSkeleton rows={8} />
                    ) : (
                        <>
                            <div>
                                <div className="overflow-x-auto">
                                    <AnimatedTable className="table-custom w-full border-separate border-spacing-y-1 whitespace-nowrap">
                                        <thead className="ltr:text-left rtl:text-right">
                                            <tr
                                                className="relative rounded-md bg-slate-50 after:absolute after:bottom-0
                    after:left-0 after:top-0 after:border-l-2
                    after:border-transparent [&.active]:after:border-custom-500"
                                            >
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">ID</th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">
                                                    Title of the Offer
                                                </th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">Product Name</th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">type of Offer</th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">price offer</th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">unit price</th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">product photo</th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">
                                                    quantity of product
                                                </th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">
                                                    Sub Category name{' '}
                                                </th>
                                                <th className="px-3.5 py-2.5 font-semibold uppercase">Details</th>
                                            </tr>
                                        </thead>
                                        <AnimatedTableBody loading={loading} itemCount={offers?.length ?? 0} animationKey={`offers-${page}`}>
                                            {offers?.map((offer: any) => (
                                                <AnimatedTableRow
                                                    rowKey={offer?.id}
                                                    detailRecord={offer}
                                                    className="relative rounded-md bg-slate-50 after:absolute after:bottom-0
                        after:left-0 after:top-0 after:border-l-2 hover:bg-[#bd902e10]
                        after:border-transparent [&.active]:after:border-custom-500"
                                                >
                                                    <td className="px-3.5 py-2.5">{offer?.id || `-`}</td>
                                                    <td className="px-3.5 py-2.5">{offer?.title || `-`}</td>

                                                    <td className="px-3.5 py-2.5 text-center">{`${offer?.product?.itemName || ``} `}</td>
                                                    <td className="px-3.5 py-2.5">
                                                        {formatStaticOffers(offer?.staticOffers)}
                                                    </td>
                                                    <td className="px-3.5 py-2.5">
                                                        {offer?.product?.priceOffer || `-`}
                                                    </td>
                                                    <td className="px-3.5 py-2.5">
                                                        {offer?.product?.unitPrice || `-`}
                                                    </td>
                                                    <td className="px-3.5 py-2.5">
                                                        <UploadImageThumb
                                                            path={offer?.product?.productPhoto?.photoPath}
                                                            alt="product photo"
                                                        />
                                                    </td>

                                                    <td className="px-3.5 py-2.5">
                                                        {offer?.product?.initialQuantity || `-`}
                                                    </td>

                                                    <td className="px-3.5 py-2.5">
                                                        {offer?.product?.subCategories?.categoryName || `-`}
                                                    </td>
                                                    <td className="px-3.5 py-2.5">
                                                        <div className="flex flex-col justify-center items-center gap-2.5">
                                                            <button
                                                                className="mx-auto group flex w-full px-2 text-xs font-semibold py-1 items-center justify-center
                                                        rounded-md border border-yellow-600
                                                        bg-white transition-all duration-300 ease-linear hover:scale-105"
                                                                onClick={() => {
                                                                    handleDeleteOffer(offer?.id);
                                                                }}
                                                            >
                                                                delete offer
                                                            </button>
                                                            <button
                                                                className="mx-auto group flex w-full px-2 text-xs font-semibold py-1 items-center justify-center
                                                        rounded-md border border-yellow-600
                                                        bg-white transition-all duration-300 ease-linear hover:scale-105"
                                                                onClick={() => {
                                                                    handleUpdateOffer(offer?.id, offer?.product?.id);
                                                                }}
                                                            >
                                                                update offer
                                                            </button>
                                                        </div>
                                                    </td>
                                                </AnimatedTableRow>
                                            ))}
                                        </AnimatedTableBody>
                                    </AnimatedTable>
                                </div>
                                {/* <Pagination
                                    perPageData={users?.totalElements}
                                    total={users?.totalPages}
                                    currentPage={page as unknown as number}
                                    changePage={changePage}
                                    length={users?.totalElements}
                                /> */}
                            </div>
                        </>
                    )}
                </div>
            </section>
        </>
    );
};

export default Offers;
